import styled from 'styled-components';
import Button from '../Button';

const WidgetButton = styled(Button)`
  font-weight: normal;
  background: ${({ theme }) => theme.palette.common.gray3};
  color: ${({ theme }) => theme.palette.common.black};
  line-height: normal;
  gap: 4px;

  .MuiButton-startIcon,
  .MuiButton-endIcon {
    margin: unset;
  }

  :hover {
    background: #e9eaeb;
    color: ${({ theme }) => theme.palette.common.black};
  }

  :disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.palette.common.gray3};

    svg {
      opacity: 0.3;
    }
  }
`;

WidgetButton.defaultProps = {
  ...WidgetButton.defaultProps,
  size: 'extraSmall',
};

export default WidgetButton;
